<template>
  <div id="addAccountContainer">
    <div v-show="showBase">
      <AccountBase ref="addBase" :baseType="baseType" :formId="formId"></AccountBase>
    </div>
    <div v-show="showRole">
      <AccountGroup ref="addRole"></AccountGroup>
    </div>
    <div v-show="showTimeStrategy">
      <AccountStrategy ref="addStrategy"></AccountStrategy>
    </div>
  </div>
</template>
<script>
import AccountBase from './accountBase';
import AccountGroup from './accountGroup';
import AccountStrategy from './accountStrategy';
import { EventBus } from "../../../plugins/eventBus";

export default {
  name: 'AddAccount',
  props: {
    index: Number
  },
  components: {
    AccountBase,
    AccountGroup,
    AccountStrategy
  },
  data() {
    return {
      baseType: 0,
      formId: 'addBaseForm',
      showBase: true,
      showRole: false,
      showTimeStrategy: false
    };
  },
  methods: {
    init() {
      this.$refs.addBase.init();
      this.$refs.addRole.getRoleList();
      this.$refs.addStrategy.getStrategyList();
    },
    getAddInfo() {
      const account = this.$refs.addBase.getAccountBase();
      const selected = this.$refs.addRole.getSelectRole();
      // if(selectedRole != null && selectedRole != '') {
      //   const roleIds = []
      //   selectedRole.forEach((role) => {
      //     roleIds.push(role.roleId);
      //   })
      //   account['roleIdList'] = roleIds;
      // }
      if(selected != null && selected != '') {
        const groupIds = []
        selected.forEach((item) => {
          groupIds.push(item.groupId);
        })
        account['groupIdList'] = groupIds;
      }
      const selectedStrategy = this.$refs.addStrategy.getSelectStrategy();
      if(selectedStrategy != null && selectedStrategy != '') {
        account['timeStrategyId'] = selectedStrategy[0].strategyId;
      }else {
        EventBus.$emit('toast', {type: 'warning', content:  `${this.$t('Security.selectTimePolicy')}`});
        return null;
      }
      return account;
    },
    validation() {
      let base_v_status = this.$refs.addBase.validateAccountBase();
      return base_v_status;
    }
  },
  watch: {
    index() {
      if (this.index === 0) {
        this.showBase = true;
        this.showRole = false;
        this.showTimeStrategy = false;
      } else if (this.index === 1) {
          this.showBase = false;
          this.showRole = true;
          this.showTimeStrategy = false;
      } else if (this.index === 2) {
        this.showBase = false;
        this.showRole = false;
        this.showTimeStrategy = true;
      }
    }
  }
};
</script>
